var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandslide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1209_45)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1209_45)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.0001,
    cy: 15.0001,
    r: 13.9583,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.34375 6.57159C6.26042 6.76603 6.23264 10.7105 6.26042 15.3771L6.34375 23.8494L14.816 23.9327C19.4826 23.9605 23.4549 23.9327 23.6493 23.8494C23.8993 23.766 23.6493 23.266 22.816 22.1827C21.6771 20.7105 21.566 20.6549 20.316 20.6549C19.2049 20.6549 18.9271 20.5438 18.3715 19.8216C18.0104 19.3771 17.2326 18.8216 16.6215 18.6271C15.7049 18.2938 15.4549 18.0716 15.2326 17.2105C15.0382 16.5438 14.5938 15.9883 13.8993 15.516C13.1215 14.9883 12.8715 14.5994 12.8715 14.016C12.8715 13.1827 12.0104 12.2383 10.9826 11.9049C10.4549 11.7383 10.3715 11.5994 10.5104 10.9605C10.7326 9.90492 9.89931 8.54381 8.20486 7.23825C6.70486 6.09936 6.53819 6.04381 6.34375 6.57159ZM9.53819 9.6827C9.84375 10.266 9.87153 10.5716 9.62153 11.2383C9.31597 12.0438 9.31597 12.0994 10.316 12.516C11.7604 13.0994 12.316 13.6827 12.316 14.5716C12.316 15.1549 12.566 15.4883 13.2882 15.9327C13.8715 16.2938 14.316 16.8216 14.4271 17.266C14.6771 18.4883 14.9271 18.7938 16.1215 19.1827C16.816 19.4327 17.566 19.9605 18.0104 20.5438C18.6493 21.3771 18.8715 21.4883 20.066 21.4883C21.2049 21.4883 21.4549 21.5994 21.9826 22.3216L22.6215 23.1549H14.816H7.03819V15.2105V7.26603L8.09375 8.09936C8.67708 8.57159 9.31597 9.26603 9.53819 9.6827Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8716 7.43281C9.89938 7.71058 10.0938 7.90503 10.2327 7.90503C10.6494 7.87725 10.566 7.23836 10.1494 7.09947C9.89938 7.01614 9.78826 7.15503 9.8716 7.43281Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5104 8.29369C12.0659 9.23813 12.0659 9.34924 12.5937 10.377C13.2881 11.7104 13.3159 11.7381 14.6492 11.5159C15.4826 11.377 15.8159 11.1548 16.2881 10.3492L16.8715 9.34924L16.2326 8.34924C15.6492 7.4048 15.5104 7.32147 14.2881 7.32147C13.0659 7.32147 12.9548 7.37702 12.5104 8.29369ZM15.4826 8.57147C16.0659 9.46035 15.8437 10.3215 14.8992 10.6826C13.8992 11.0715 13.7604 11.0159 13.2881 10.0715C12.8715 9.29369 12.8715 9.1548 13.2881 8.54369C13.8715 7.6548 14.8992 7.68258 15.4826 8.57147Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6493 7.62706C17.7048 7.82151 17.927 8.04373 18.1215 8.09929C18.3437 8.18262 18.4548 8.07151 18.3715 7.84929C18.3159 7.65484 18.0937 7.43262 17.8993 7.37706C17.677 7.29373 17.5659 7.40484 17.6493 7.62706Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9826 9.51591C18.4271 10.3215 18.4271 10.377 18.8993 11.4048C19.3715 12.377 19.5104 12.4604 20.3715 12.377C21.3438 12.2937 22.2882 11.4604 22.316 10.7104C22.316 10.4881 22.066 9.96036 21.7326 9.51591C20.9549 8.4048 19.7882 8.4048 18.9826 9.51591ZM21.2604 10.2659C21.566 10.877 21.5382 11.0437 21.066 11.377C20.316 11.9326 19.8438 11.8492 19.566 11.127C19.0104 9.71036 20.6493 8.87702 21.2604 10.2659Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1493 13.016C14.2604 13.266 14.4548 13.4049 14.5937 13.3771C15.0104 13.2382 14.8993 12.7382 14.4271 12.6549C14.1215 12.5993 14.0382 12.7104 14.1493 13.016Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8715 14.0161C15.3993 14.8216 15.3993 14.9049 15.9548 15.9883C16.4826 17.0161 16.5937 17.0994 17.3715 16.9327C17.8437 16.8494 18.2882 16.7661 18.3993 16.7661C18.5104 16.7661 18.8159 16.3772 19.0937 15.9327C19.5659 15.0994 19.5659 15.0716 18.9826 14.1272C18.4826 13.2938 18.2326 13.1549 17.3715 13.1549C16.5104 13.1549 16.2604 13.2938 15.8715 14.0161ZM18.3715 14.5716C18.677 15.0716 18.677 15.2383 18.2604 15.6827C17.5937 16.4049 16.8993 16.3494 16.5104 15.4883C16.2604 14.9327 16.2604 14.6549 16.5104 14.3772C16.9826 13.7938 17.9548 13.9049 18.3715 14.5716Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9828 14.0439C21.1216 14.4605 21.7605 14.5439 21.7883 14.1272C21.7883 13.9605 21.5939 13.7939 21.3161 13.7661C21.0383 13.6827 20.8994 13.7939 20.9828 14.0439Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1494 17.4605C19.8716 18.0438 19.8994 18.3494 20.2327 18.9882C20.7605 20.016 21.5382 20.0716 22.4827 19.1271C23.1494 18.4605 23.1494 18.4049 22.7327 17.5994C22.3716 16.9327 22.1216 16.766 21.3716 16.766C20.6771 16.766 20.3994 16.9327 20.1494 17.4605ZM22.1216 17.9882C22.2882 18.4049 21.816 18.9882 21.316 18.9882C20.9271 18.9882 20.566 18.2105 20.816 17.8494C21.0382 17.4605 21.9549 17.5438 22.1216 17.9882Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7326 17.8772C17.6215 18.0717 17.7049 18.3217 17.8993 18.4605C18.3715 18.7383 18.6215 18.2383 18.2049 17.8217C18.0382 17.655 17.8715 17.655 17.7326 17.8772Z",
    fill: "#FFA500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1209_45",
    x: -0.958252,
    y: -0.958252,
    width: 31.9167,
    height: 31.9167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1209_45"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1209_45",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1209_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandslide);
export default __webpack_public_path__ + "static/media/landslide.fa1a46e1865eded0195742672559d1fb.svg";
export { ForwardRef as ReactComponent };